import { render, staticRenderFns } from "./AddInformation.vue?vue&type=template&id=c85910e6&scoped=true"
import script from "./AddInformation.vue?vue&type=script&lang=js"
export * from "./AddInformation.vue?vue&type=script&lang=js"
import style0 from "./AddInformation.vue?vue&type=style&index=0&id=c85910e6&prod&lang=scss&scoped=true"
import style1 from "./AddInformation.vue?vue&type=style&index=1&id=c85910e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85910e6",
  null
  
)

export default component.exports